<template>
    <div class="container" id="contact">
        <div v-show="emailNotSubmitted" class="max-w-3xl mx-auto text-center pb-20">
            <h2 class="h2">{{ $t('contactus') }}</h2>
        </div>
        <div v-show="emailNotSubmitted == false" class="max-w-3xl mx-auto text-center pb-20">
            <h2 class="h2">{{ $t('thanks') }}</h2>
        </div>
        <transition name="fade" mode="out-in">
            <div id="contact-form" v-show="emailNotSubmitted">
                <form ref="form" @submit.prevent="sendEmail">
                    <label>{{ $t('your-name') }}</label>
                    <input type="text" name="from_name">
                    <label>{{ $t('your-email') }}</label>
                    <input type="email" name="from_email">
                    <label>{{ $t('your-phone') }}</label>
                    <input type="tel" name="from_phone">
                    <label>{{ $t('your-message') }}</label>
                    <textarea name="message"></textarea>
                    <input type="submit" value="Versturen">
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
import emailjs from '@emailjs/browser';

export default {
    name: 'ContactForm',
    methods: {
        sendEmail() {
            //console.log('SUCCESS!');
            this.emailNotSubmitted = false;

            emailjs.sendForm('service_maraxis_gmail', 'struvital_contact', this.$refs.form, 'e7HQNK61pzM0odVkW')
                .then((result) => {
                    // eslint-disable-next-line
                    console.log('SUCCESS!', result.text);
                }, (error) => {
                    // eslint-disable-next-line
                    console.log('FAILED...', error.text);
                });
        }
    },
    data: function () {
        return {
            emailNotSubmitted : {
                type: Boolean,
                default: true,
            }
        }
    }

}
</script>
<style scoped>
* {
    box-sizing: border-box;
}

.container {
    display: block;
    margin: auto;
    text-align: center;
    border-radius: 8px;
    background-color: #f2f2f2;
    padding: 32px;
    width: 60%;
}

@media (max-width: 640px) {
    .container {
        width: 90%;
        padding: 20px;
    }
}

label {
    float: left;
    font-weight: 500;
    margin-bottom: 2px;
}

input[type=text],
[type=email],
[type=tel],
textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
    transition: border-color 0.2s ease;
}

input[type=text]:focus,
[type=email]:focus,
[type=tel]:focus,
textarea:focus {
    outline: none;
    border-color: #585bf2;
    box-shadow: 0 0 0 3px rgba(88, 91, 242, 0.15);
}

input[type=submit] {
    background-color: #585bf2;
    color: white;
    padding: 14px 32px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: background-color 0.2s ease;
}

input[type=submit]:hover {
    background-color: #4547d0;
}</style>